import React from "react";
import Helmet from "react-helmet";
import { getGraphNode } from "../selectors";
import NavBar from "../components/NavBar";
import Section from "../components/blocks/Section";
import ContactForm from "../components/ContactForm";
import favicon from "../../assets/logofavcon@2x.png";

export default ({ data }) => {
  const content = getGraphNode(data, "ContactPage");
  return (
    <div>
      <Helmet
        title="Contraline Contact"
        meta={[{ name: "Contraline", content: "Contact" }]}
      >
        <link rel="icon" type="image/png" href={favicon} />
      </Helmet>
      <NavBar color="dark" />
      <Section>
        <ContactForm title={content.title} address={content.address} />
      </Section>
    </div>
  );
};

export const pageQuery = graphql`
  query ContactPageQuery {
    allContentfulContactPage {
      edges {
        node {
          id
          address
          title
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/contact.js